import { PromoCodeKind, PromoVoidReason, VoidOnPlanChange, PromoIneligibilityReason } from '../promo_code';
import { validateEnumTranslations } from '../../safety_checks';

export const TRANSLATE_KEY_PROMO_CODE_KIND = 'PROMO_CODE_KIND_';
export const TRANSLATE_KEY_VOID_ON_PLAN_CHANGE = 'VOID_ON_PLAN_CHANGE_';
export const TRANSLATE_KEY_PROMO_VOID_REASON = 'PROMO_VOID_REASON_';
export const TRANSLATE_KEY_PROMO_INELIGIBILITY = 'PROMO_INELIGIBILITY_';

export const PromoCodeKindTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_PROMO_CODE_KIND}${PromoCodeKind.PERCENT}`]: 'Pourcentage',
    [`${TRANSLATE_KEY_PROMO_CODE_KIND}${PromoCodeKind.FIXED_AMOUNT_MINOR}`]: 'Montant fixe',
    [`${TRANSLATE_KEY_PROMO_CODE_KIND}${PromoCodeKind.LOCKED_PRICE_MINOR}`]: 'Prix verrouillé',
    [`${TRANSLATE_KEY_PROMO_CODE_KIND}${PromoCodeKind.BUDGET_MINOR}`]: 'Enveloppe (budget consommé)',
  },
};

export const VoidOnPlanChangeTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_VOID_ON_PLAN_CHANGE}${VoidOnPlanChange.NEVER}`]: 'Jamais désactivé sur changement de plan',
    [`${TRANSLATE_KEY_VOID_ON_PLAN_CHANGE}${VoidOnPlanChange.DOWNGRADE_ONLY}`]:
      'Désactivé en cas de downgrade uniquement',
    [`${TRANSLATE_KEY_VOID_ON_PLAN_CHANGE}${VoidOnPlanChange.ANY_CHANGE}`]: 'Désactivé sur tout changement de plan',
  },
};

export const PromoVoidReasonTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_PROMO_VOID_REASON}${PromoVoidReason.PLAN_CHANGE}`]: 'Changement de plan',
    [`${TRANSLATE_KEY_PROMO_VOID_REASON}${PromoVoidReason.DOWNGRADE}`]: 'Downgrade vers un plan inférieur',
    [`${TRANSLATE_KEY_PROMO_VOID_REASON}${PromoVoidReason.ADDON_ADDED}`]: "Ajout d'une option",
    [`${TRANSLATE_KEY_PROMO_VOID_REASON}${PromoVoidReason.EXPIRED}`]: 'Durée du code écoulée',
    [`${TRANSLATE_KEY_PROMO_VOID_REASON}${PromoVoidReason.MAX_REDEMPTIONS_REACHED}`]:
      "Nombre maximum d'utilisations atteint",
    [`${TRANSLATE_KEY_PROMO_VOID_REASON}${PromoVoidReason.MANUAL_ADMIN}`]:
      'Désactivé manuellement par un administrateur',
  },
};

export const PromoIneligibilityReasonTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_PROMO_INELIGIBILITY}${PromoIneligibilityReason.NOT_ELIGIBLE_PLAN}`]:
      "Ce code n'est pas applicable à votre plan actuel",
    [`${TRANSLATE_KEY_PROMO_INELIGIBILITY}${PromoIneligibilityReason.NOT_ELIGIBLE_SIZE}`]:
      "Ce code n'est pas applicable à votre formule (solo/équipe)",
    [`${TRANSLATE_KEY_PROMO_INELIGIBILITY}${PromoIneligibilityReason.NOT_ELIGIBLE_BILLING}`]:
      "Ce code n'est pas applicable à votre fréquence de facturation",
    [`${TRANSLATE_KEY_PROMO_INELIGIBILITY}${PromoIneligibilityReason.EXPIRED}`]: 'Ce code a expiré',
    [`${TRANSLATE_KEY_PROMO_INELIGIBILITY}${PromoIneligibilityReason.MAX_REDEMPTIONS_REACHED}`]:
      "Ce code a atteint son nombre maximum d'utilisations",
    [`${TRANSLATE_KEY_PROMO_INELIGIBILITY}${PromoIneligibilityReason.ALREADY_REDEEMED}`]:
      'Vous avez déjà utilisé ce code',
    [`${TRANSLATE_KEY_PROMO_INELIGIBILITY}${PromoIneligibilityReason.STACKING_FORBIDDEN}`]:
      'Un code promo non cumulable est déjà actif sur votre compte',
    [`${TRANSLATE_KEY_PROMO_INELIGIBILITY}${PromoIneligibilityReason.CODE_NOT_FOUND}`]: "Ce code n'existe pas",
    [`${TRANSLATE_KEY_PROMO_INELIGIBILITY}${PromoIneligibilityReason.CODE_INACTIVE}`]: "Ce code n'est plus actif",
    [`${TRANSLATE_KEY_PROMO_INELIGIBILITY}${PromoIneligibilityReason.OUTSIDE_VALIDITY_WINDOW}`]:
      "Ce code n'est pas encore valide ou n'est plus valide",
    [`${TRANSLATE_KEY_PROMO_INELIGIBILITY}${PromoIneligibilityReason.TARGETED_TO_OTHER_PRO}`]:
      'Ce code est réservé à un autre compte',
    [`${TRANSLATE_KEY_PROMO_INELIGIBILITY}${PromoIneligibilityReason.ZERO_AMOUNT_AT_CHECKOUT}`]:
      'Ce code ramènerait le montant à régler à 0 € : contactez-nous pour en bénéficier',
    [`${TRANSLATE_KEY_PROMO_INELIGIBILITY}${PromoIneligibilityReason.NOT_APPLICABLE_TO_ORDER}`]:
      "Ce code ne s'applique à aucune ligne de votre commande",
  },
};

//DONT TOUCH below this line
validateEnumTranslations(PromoCodeKind, PromoCodeKindTranslation, TRANSLATE_KEY_PROMO_CODE_KIND, true);
validateEnumTranslations(VoidOnPlanChange, VoidOnPlanChangeTranslation, TRANSLATE_KEY_VOID_ON_PLAN_CHANGE, true);
validateEnumTranslations(PromoVoidReason, PromoVoidReasonTranslation, TRANSLATE_KEY_PROMO_VOID_REASON, true);
validateEnumTranslations(
  PromoIneligibilityReason,
  PromoIneligibilityReasonTranslation,
  TRANSLATE_KEY_PROMO_INELIGIBILITY,
  true,
);
